// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { ProductBaseElement } from './ProductBaseElement';
import { APP } from '../../../../../com/MetaPattern/MDA/MD/Base/APP';
import { ProductComponent } from './ProductComponent';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 产品应用 实体类
 * 产品对应的应用
 */
export class ProductAPP extends ProductBaseElement {
  /** 应用 的ID */
  private _aPP_ID: string;

  /** 获取：应用 的ID */
  public get aPP_ID() {
    return this._aPP_ID;
  }

  /** 设置：应用 的ID */
  public set aPP_ID(value: string) {
    this._aPP_ID = value;
  }

  /** 应用  */
  private _aPP: APP;

  /** 获取：应用  */
  public get aPP() {
    return this._aPP;
  }

  /** 设置：应用  */
  public set aPP(value: APP) {
    this._aPP = value;
    if (value !== null) {
      this.aPP_ID = value.id;
    } else {
      this.aPP_ID = '';
    }
  }

  /** 产品组件 的ID */
  private _component_ID: string;

  /** 获取：产品组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：产品组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 产品组件  */
  private _component: ProductComponent;

  /** 获取：产品组件  */
  public get component() {
    return this._component;
  }

  /** 设置：产品组件  */
  public set component(value: ProductComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  constructor() {
    super();
    this._aPP_ID = '';
    this._aPP = null;
    this._component_ID = '';
    this._component = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ProductAPP, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.aPP_ID = element.aPP_ID;
      if (hasReference && element.aPP !== null) {
        this.aPP = element.aPP;
      }
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.aPP_ID = json.APP_ID;
    // if (json.APP !== null) {
    //   this.aPP = APP.Create(json.APP);
    // }
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = ProductComponent.Create(json.Component);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.APP_ID = this.aPP_ID;
    json.Component_ID = this.component_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'aPP', '应用', EnumDataType.Reference, this.aPP, true, '产品包含的应用', 'APP', 'PGRowAPPValue');
    return context;
  }

  static Create(json: any): ProductAPP {
    const productAPP = new ProductAPP();
    productAPP.Deserialize(json);
    productAPP.json = json;
    return productAPP;
  }
}
